import { render, staticRenderFns } from "./TemaField.vue?vue&type=template&id=438ec506"
import script from "./TemaField.vue?vue&type=script&lang=js"
export * from "./TemaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports